//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
import moment from 'moment';
export default {
  name: 'FeelingTable',
  components: {
    DataTable: DataTable
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Date'),
        columnId: 'datetime',
        type: 'datetime',
        show: true,
        default: function _default() {
          return moment().format('YYYY-MM-DDTHH:mm');
        }
      }, {
        name: t('health', 'Mood'),
        columnId: 'mood',
        type: 'select',
        show: this.person.feelingColumnMood,
        options: [{
          id: 0,
          label: t('health', 'Fantastic', {})
        }, {
          id: 1,
          label: t('health', 'Good', {})
        }, {
          id: 2,
          label: t('health', 'Okay', {})
        }, {
          id: 3,
          label: t('health', 'Bad', {})
        }, {
          id: 4,
          label: t('health', 'Horrible', {})
        }]
      }, {
        name: t('health', 'Sadness level'),
        columnId: 'sadnessLevel',
        type: 'select',
        show: this.person.feelingColumnSadnessLevel,
        options: [{
          id: 0,
          label: t('health', 'None', {})
        }, {
          id: 1,
          label: t('health', 'Low', {})
        }, {
          id: 2,
          label: t('health', 'Medium', {})
        }, {
          id: 3,
          label: t('health', 'High', {})
        }]
      }, {
        name: t('health', 'Symptoms'),
        columnId: 'symptoms',
        show: this.person.feelingColumnSymptoms,
        type: 'multiselect',
        options: [t('health', 'Fatigue', {}), t('health', 'No Appetite', {}), t('health', 'Overeating', {}), t('health', 'Repeated thoughts', {}), t('health', 'Unmotivated', {}), t('health', 'Irritable', {}), t('health', 'Lack of Concentration', {}), t('health', 'Anxiety', {}), t('health', 'Isolation self from others', {}), t('health', 'Thoughts of death/sicide', {}), t('health', 'Feeling hopeless', {}), t('health', 'Feeling worthless', {}), t('health', 'Indecisive', {})]
      }, {
        name: t('health', 'Attacks'),
        columnId: 'attacks',
        show: this.person.feelingColumnAttacks,
        type: 'multiselect',
        options: [t('health', 'Panic attack', {}), t('health', 'Fit of range', {}), t('health', 'Asthma attack', {})]
      }, {
        name: t('health', 'Medication'),
        columnId: 'medication',
        type: 'longtext',
        show: this.person.feelingColumnMedication,
        placeholder: t('health', 'What medicine did you take?', {})
      }, {
        name: t('health', 'Pain'),
        columnId: 'pain',
        type: 'select',
        show: this.person.feelingColumnPain,
        options: [{
          id: 0,
          label: 'No pain'
        }, {
          id: 1,
          label: 'Very Mild'
        }, {
          id: 2,
          label: 'Discomforting'
        }, {
          id: 3,
          label: 'Tolerable'
        }, {
          id: 4,
          label: 'Distressing'
        }, {
          id: 5,
          label: 'Very Distressing'
        }, {
          id: 6,
          label: 'Intense'
        }, {
          id: 7,
          label: 'Very intense'
        }, {
          id: 8,
          label: 'Utterly Horrible'
        }, {
          id: 9,
          label: 'Excruciating'
        }, {
          id: 10,
          label: 'Unimaginable'
        }]
      }, {
        name: t('health', 'Energy'),
        columnId: 'energy',
        type: 'select',
        show: this.person.feelingColumnEnergy,
        options: [{
          id: 0,
          label: 'Bedridden'
        }, {
          id: 1,
          label: 'Very low'
        }, {
          id: 2,
          label: 'Low'
        }, {
          id: 3,
          label: 'Somewhat low'
        }, {
          id: 4,
          label: 'Below normal'
        }, {
          id: 5,
          label: 'Normal'
        }, {
          id: 6,
          label: 'Above normal'
        }, {
          id: 7,
          label: 'Somewhat high'
        }, {
          id: 8,
          label: 'High'
        }, {
          id: 9,
          label: 'Very high'
        }, {
          id: 10,
          label: 'Indescribable'
        }]
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true,
        placeholder: t('health', 'Give some comment, if you want...', {}),
        maxlength: 1000
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('feelingDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      console.debug('update item', item);
      this.$store.dispatch('feelingDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('feelingDatasetsDelete', item);
    }
  }
};